var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeslike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741:2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.401 11.2129C19.7278 11.2129 19.9927 10.948 19.9927 10.6212V1.93147C19.9927 1.60471 19.7278 1.33982 19.401 1.33982H15.8365V11.2129H19.401Z",
    fill: "#121933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00753212 7.9458C0.00753212 8.69686 0.411089 9.35545 1.01273 9.71616C0.782222 10.049 0.647026 10.4528 0.647026 10.8874C0.647026 12.0247 1.57226 12.9499 2.70949 12.9499L7.06333 12.9499C6.92989 13.5546 6.74739 14.462 6.62032 15.4119C6.28961 17.8838 6.51563 19.2547 7.33153 19.7261C7.8402 20.02 8.38864 20.0796 8.87583 19.8941C9.2522 19.7508 9.76048 19.3983 10.0501 18.5333L11.1944 15.5371C11.7745 14.1044 13.5511 12.6003 14.6528 11.7687V1.0781C12.6109 0.362629 10.4801 -2.67029e-05 8.30626 -2.67029e-05H3.56227C2.42504 -2.67029e-05 1.4998 0.925209 1.4998 2.06244C1.4998 2.46068 1.61328 2.83294 1.80957 3.14853C1.12203 3.48338 0.647102 4.18939 0.647102 5.00412C0.647102 5.43881 0.782298 5.84252 1.01281 6.17541C0.411087 6.53611 0.00753212 7.19475 0.00753212 7.9458Z",
    fill: "#121933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741:2618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 20) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeslike);
export default __webpack_public_path__ + "static/media/icon-deslike.a099d527943ed98bf0998aea3d05ef89.svg";
export { ForwardRef as ReactComponent };